/**
 * Crea la disposición del tragamonedas
 * @param {*} scene
 */
export function crearPalanca(scene) {
  scene.palanca = scene.add
    .image(709, 215, "palanca1Estatica")
    .setInteractive();
  scene.palanca.setDepth(400);

  scene.anims.create({
    key: "palancaAnimada",
    frames: scene.anims.generateFrameNumbers("palanca1Movimiento", {
      start: 0,
      end: 8,
    }),
    frameRate: 10,
    repeat: -1,
  });

  scene.palancaAnimada = scene.add
    .sprite(709, 215, "palancaAnimada")
    .setVisible(false);
  scene.palancaAnimada.setDepth(400);

  scene.palanca.on("pointerdown", () => {
    if (!scene.noVaMas) {
      scene.jugarApuesta();
      scene.palanca.setVisible(false);
      scene.palancaAnimada.setVisible(true);
      scene.palancaAnimada.play("palancaAnimada");

      scene.time.delayedCall(900, () => {
        scene.palancaAnimada.setVisible(false);
        scene.palancaAnimada.stop();
        scene.palanca.setVisible(true);
      });
    }
  });
}
